import React from "react";
import { ChevronDown } from "lucide-react";

const MobileFloorBar = ({
  rootLocations = [],
  activeRootLocationId,
  setActiveRootLocationId,
  selectedDate,
  onPrevDay,
  onNextDay,
  routeLabel,
  showDateNav = true,
}) => {
  const active = rootLocations.find((r) => String(r.id) === String(activeRootLocationId));
  const label = active?.name || (rootLocations[0]?.name ?? "Floorplan");

  const formatDate = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("hu-HU", {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
    });
  };

  return (
    <div className="shrink-0 bg-slate-800/95 border-b border-slate-700 px-2 py-1.5 flex flex-col gap-1 z-20">
      <div className="flex items-center gap-2 min-w-0">
        <label className="sr-only">Floorplan</label>
        <div className="relative flex-1 min-w-0">
          <select
            value={activeRootLocationId ?? ""}
            onChange={(e) => setActiveRootLocationId(e.target.value ? Number(e.target.value) : null)}
            className="w-full appearance-none bg-slate-900 border border-slate-600 rounded-md pl-2 pr-7 py-1.5 text-sm text-slate-100 truncate"
          >
            {rootLocations.length === 0 && <option value="">Nincs floorplan</option>}
            {rootLocations.map((loc) => (
              <option key={loc.id} value={loc.id}>
                {loc.name}
              </option>
            ))}
          </select>
          <ChevronDown size={14} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
        </div>
      </div>
      {showDateNav && selectedDate && (
        <div className="flex items-center gap-1 text-xs text-slate-300">
          <button type="button" onClick={onPrevDay} className="px-2 py-0.5 rounded hover:bg-slate-700" aria-label="Elozo nap">
            ‹
          </button>
          <span className="flex-1 text-center font-medium truncate">{formatDate(selectedDate)}</span>
          <button type="button" onClick={onNextDay} className="px-2 py-0.5 rounded hover:bg-slate-700" aria-label="Kovetkezo nap">
            ›
          </button>
        </div>
      )}
      {routeLabel && (
        <div className="text-[11px] text-teal-300 truncate px-1">{routeLabel}</div>
      )}
    </div>
  );
};

export default MobileFloorBar;
